import React from "react";
import "../../assets/img/Logo.png"
import "./Hero.scss"
class Hero extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
    }	

	render() {
		return (
			<div className="heroSection" ref={this.props.refs}>
				<div className="HeroWrapper">
					<div className="titleWrapper">
						<div className="supertitle">
							McMaster University Capstone Project 2019
						</div>
						<div className="title1">
							Agriboost
						</div>
						<div className="subtitle1">
							{/* First Place Winners of McMaster University's <br/> 2019 Computing & Software Capstone Competition  */}
							Precision Agriculture Weather Station with Real-Time Analytics and Alerts
						</div>
					</div>
					<img className="iMacImage" src={require("assets/img/Untitled-1.png")} alt=""/>
				</div>
			</div>
		);
	}
}
export default Hero;
